import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import InputMask from 'react-input-mask';
import { useReCaptcha } from "next-recaptcha-v3";
import { fetchPostEmailSendFinancing } from "../../../services/api";

export default function FinancingForm() {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const { control, register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("financingSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendFinancing({
            addressCity: data.txtAddressCity,
            addressComplement: data.txtAddressComplement,
            addressFederativeUnit: data.ddlAddressFederativeUnit,
            addressNeghborhood: data.txtAddressNeighborhood,
            addressNumber: data.txtAddressNumber,
            addressPostalCode: data.txtAddressPostalCode,
            addressResidenceTime: data.txtResidenceTime,
            addressResidenceType: data.ddlResidenceType,
            addressStreet: data.txtAddressStreet,
            bankReferenceAccount: data.txtBankAccount,
            bankReferenceAgency: data.txtBankAgency,
            bankReferenceBank: data.txtBankName,
            bankReferenceCustomerSince: data.txtBankCustomerSince,
            birthDate: data.txtBirthDate,
            cellPhone: data.txtCellPhone,
            cpf: data.txtCPF,
            email: data.txtEmail,
            entryValue: data.txtEntryValue,
            fatherName: data.txtFathersName,
            financingValue: data.txtFinancingValue,
            hasCNH: data.ddlHasCNH,
            motherName: data.txtMothersName,
            name: data.txtName,
            paymentTerm: data.txtPaymentTime,
            rg: data.txtRG,
            rgIssueDate: data.txtEmissionDate,
            rgIssuerOrganization: data.txtEmissionIssuer,
            vehicle: data.txtVehicle,
            vehicleValue: data.txtVehiclePrice,
            workActivityAddressCity: data.txtCompanyAddressCity,
            workActivityAddressComplement: data.txtCompanyAddressComplement,
            workActivityAddressFederativeUnit: data.ddlCompanyAddressFederativeUnit,
            workActivityAddressNeighborhood: data.txtCompanyAddressNeighborhood,
            workActivityAddressNumber: data.txtCompanyAddressNumber,
            workActivityAddressPostalCode: data.txtCompanyAddressPostalCode,
            workActivityAddressStreet: data.txtCompanyAddressStreet,
            workActivityCompany: data.txtCompanyName,
            workActivityOffice: data.txtWorkOffice,
            workActivityOtherLace: data.txtOtherIncome,
            workActivitySalary: data.txtSalary,
            workActivitySector: data.txtWorkSector,
            workActivityTimeOfWork: data.txtWorkTime,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtAddressCity', '');
                    setValue('txtAddressComplement', '');
                    setValue('ddlAddressFederativeUnit', '');
                    setValue('txtAddressNeighborhood', '');
                    setValue('txtAddressNumber', '');
                    setValue('txtAddressPostalCode', '');
                    setValue('txtResidenceTime', '');
                    setValue('ddlResidenceType', '');
                    setValue('txtAddressStreet', '');
                    setValue('txtBankAccount', '');
                    setValue('txtBankAgency', '');
                    setValue('txtBankName', '');
                    setValue('txtBankCustomerSince', '');
                    setValue('txtBirthDate', '');
                    setValue('txtCellPhone', '');
                    setValue('txtCPF', '');
                    setValue('txtEmail', '');
                    setValue('txtEntryValue', '');
                    setValue('txtFathersName', '');
                    setValue('txtFinancingValue', '');
                    setValue('ddlHasCNH', '');
                    setValue('txtMothersName', '');
                    setValue('txtName', '');
                    setValue('txtPaymentTime', '');
                    setValue('txtRG', '');
                    setValue('txtEmissionDate', '');
                    setValue('txtEmissionIssuer', '');
                    setValue('txtVehicle', '');
                    setValue('txtVehiclePrice', '');
                    setValue('txtCompanyAddressCity', '');
                    setValue('txtCompanyAddressComplement', '');
                    setValue('ddlCompanyAddressFederativeUnit', '');
                    setValue('txtCompanyAddressNeighborhood', '');
                    setValue('txtCompanyAddressNumber', '');
                    setValue('txtCompanyAddressPostalCode', '');
                    setValue('txtCompanyAddressStreet', '');
                    setValue('txtCompanyName', '');
                    setValue('txtWorkOffice', '');
                    setValue('txtOtherIncome', '');
                    setValue('txtSalary', '');
                    setValue('txtWorkSector', '');
                    setValue('txtWorkTime', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }
    return (
        <section className="car-listing-section ptb-40">
            <div className="container">
                <div className="row">
                    <div className="col-xl-3">
                        <div className="car_listing_sidebar">
                            <h4 className="mb-2">Financiamento</h4>
                            <p className="mb-0">Informe os dados que iremos aprovar seu crédito on-line.</p>
                            <div className="car_listing_nav mt-4">
                                <ul>
                                    <li><a href="#vehicle_data" className="active">Dados do Veículo</a></li>
                                    <li><a href="#personal_data">Dados Pessoais</a></li>
                                    <li><a href="#address_data">Endereço</a></li>
                                    <li><a href="#professional_activity_data">Atividade Profissional</a></li>
                                    <li><a href="#bank_reference_data">Referência Bancária</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-9">
                        <div className="car_listing_form">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="listing_info_box bg-white rounded" id="vehicle_data">
                                    <h5 className="mb-4">Dados do Veículo</h5>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="input-field">
                                                <label>Veículo</label>
                                                <input type="text" placeholder="Ex.: Mercedes benz e 400 coupe 2017" {...register("txtVehicle", { required: true })} required={errors.txtVehicle} />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="input-field">
                                                <label>Valor do Veículo</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        placeholder={'Ex.: 50.000,00'}
                                                        prefix='R$ '
                                                        required={errors.txtVehiclePrice}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtVehiclePrice"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="input-field">
                                                <label>Valor de Entrada</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        placeholder={'Ex.: 20.000,00'}
                                                        prefix='R$ '
                                                        required={errors.txtEntryValue}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtEntryValue"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="input-field">
                                                <label>Valor do Financiamento</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        placeholder={'Ex.: 30.000,00'}
                                                        prefix='R$ '
                                                        required={errors.txtFinancingValue}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtFinancingValue"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="input-field">
                                                <label>Prazo de Pagamento</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        placeholder={'Ex.: 48 meses'}
                                                        suffix=' meses'
                                                        required={errors.txtPaymentTime}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtPaymentTime"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="listing_info_box bg-white rounded mt-40" id="personal_data">
                                    <h5 className="mb-4">Dados Pessoais</h5>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Nome Completo</label>
                                                <input type="text" placeholder="Ex.: Joaquim Santos Silva" {...register("txtName", { required: true })} required={errors.txtName} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Email</label>
                                                <input type="email" placeholder="Ex.: joaquimsantossilva@yahoo.com" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Nome Completo da Mãe</label>
                                                <input type="text" placeholder="Ex.: Maria Santos Silva" {...register("txtMothersName", { required: true })} required={errors.txtMothersName} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Nome Completo do Pai</label>
                                                <input type="text" placeholder="Ex.: Osvaldo Santos Silva" {...register("txtFathersName", { required: true })} required={errors.txtFathersName} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Data de Nascimento</label>
                                                <input type={'date'} {...register("txtBirthDate", { required: true })} required={errors.txtBirthDate} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Celular</label>
                                                <InputMask type={'tel'} placeholder="Ex.: (11) 99999-9999" mask="(99) 99999-9999" maskChar=" " {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>CPF</label>
                                                <InputMask type={'text'} placeholder="Ex.: 333.222.111-00" mask="999.999.999-99" maskChar=" " {...register("txtCPF", { required: true })} required={errors.txtCPF} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>RG</label>
                                                <input type={'text'} placeholder="Ex.: 99.999.999-x" {...register("txtRG", { required: true })} required={errors.txtRG} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Emissão</label>
                                                <input type={'date'} {...register("txtEmissionDate", { required: true })} required={errors.txtEmissionDate} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Órgão Emissor</label>
                                                <input type={'text'} placeholder="Ex.: SSP/SP" {...register("txtEmissionIssuer", { required: true })} required={errors.txtEmissionIssuer} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Possui CNH?</label>
                                                <select className="form-select" {...register("ddlHasCNH", { required: true })} required={errors.ddlHasCNH}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="listing_info_box bg-white rounded mt-40" id="address_data">
                                    <h5 className="mb-4">Endereço</h5>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Logradouro</label>
                                                <input type="text" placeholder="Ex.: Av. dos Sabiás" {...register("txtAddressStreet", { required: true })} required={errors.txtAddressStreet} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Número</label>
                                                <input type={'number'} placeholder="Ex.: 1.200" {...register("txtAddressNumber", { required: true })} required={errors.txtAddressNumber} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Complemento</label>
                                                <input type={'text'} placeholder="Ex.: Sala 12" {...register("txtAddressComplement")} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Bairro</label>
                                                <input type={'text'} placeholder="Ex.: Jardim América" {...register("txtAddressNeighborhood", { required: true })} required={errors.txtAddressNeighborhood} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>CEP</label>
                                                <InputMask type={'text'} placeholder="Ex.: 02030-010" mask="99999-999" maskChar=" " {...register("txtAddressPostalCode", { required: true })} required={errors.txtAddressPostalCode} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Cidade</label>
                                                <input type={'text'} placeholder="Ex.: São Paulo" {...register("txtAddressCity", { required: true })} required={errors.txtAddressCity} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>UF</label>
                                                <select className="form-select" {...register("ddlAddressFederativeUnit", { required: true })} required={errors.ddlAddressFederativeUnit}>
                                                    <option value={''}></option>
                                                    <option value={'Acre'}>Acre</option>
                                                    <option value={'Alagoas'}>Alagoas</option>
                                                    <option value={'Amapá'}>Amapá</option>
                                                    <option value={'Amazonas'}>Amazonas</option>
                                                    <option value={'Bahia'}>Bahia</option>
                                                    <option value={'Ceará'}>Ceará</option>
                                                    <option value={'Distrito Federal'}>Distrito Federal</option>
                                                    <option value={'Espírito Santo'}>Espírito Santo</option>
                                                    <option value={'Goiás'}>Goiás</option>
                                                    <option value={'Maranhão'}>Maranhão</option>
                                                    <option value={'Mato Grosso'}>Mato Grosso</option>
                                                    <option value={'Mato Grosso do Sul'}>Mato Grosso do Sul</option>
                                                    <option value={'Minas Gerais'}>Minas Gerais</option>
                                                    <option value={'Paraíba'}>Paraíba</option>
                                                    <option value={'Paraná'}>Paraná</option>
                                                    <option value={'Pernambuco'}>Pernambuco</option>
                                                    <option value={'Piauí'}>Piauí</option>
                                                    <option value={'Rio de Janeiro'}>Rio de Janeiro</option>
                                                    <option value={'Rio Grande do Norte'}>Rio Grande do Norte</option>
                                                    <option value={'Rio Grande do Sul'}>Rio Grande do Sul</option>
                                                    <option value={'Rondônia'}>Rondônia</option>
                                                    <option value={'Roraima'}>Roraima</option>
                                                    <option value={'Santa Catarina'}>Santa Catarina</option>
                                                    <option value={'São Paulo'}>São Paulo</option>
                                                    <option value={'Sergipe'}>Sergipe</option>
                                                    <option value={'Tocantins'}>Tocantins</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Tipo de Residência</label>
                                                <select className="form-select" {...register("ddlResidenceType", { required: true })} required={errors.ddlResidenceType}>
                                                    <option value={''}></option>
                                                    <option>Casa</option>
                                                    <option>Apartamento</option>
                                                    <option>Outros</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Tempo de Residência</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        placeholder={'Ex.: 5 anos'}
                                                        suffix=' anos'
                                                        required={errors.txtResidenceTime}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtResidenceTime"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="listing_info_box bg-white rounded mt-40" id="professional_activity_data">
                                    <h5 className="mb-4">Atividade Profissional</h5>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Empresa Onde Trabalha</label>
                                                <input type={'text'} placeholder="Ex.: Banco do Brasil" {...register("txtCompanyName", { required: true })} required={errors.txtCompanyName} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Tempo de Trabalho</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        placeholder={'Ex.: 5 anos'}
                                                        suffix=' anos'
                                                        required={errors.txtWorkTime}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtWorkTime"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Cargo</label>
                                                <input type={'text'} placeholder="Ex.: Assistente Técnico" {...register("txtWorkOffice", { required: true })} required={errors.txtWorkOffice} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Setor</label>
                                                <input type={'text'} placeholder="Ex.: Almoxarifado" {...register("txtWorkSector", { required: true })} required={errors.txtWorkSector} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Logradouro da Empresa</label>
                                                <input type={'text'} placeholder="Ex.: Av. dos Sabiás" {...register("txtCompanyAddressStreet", { required: true })} required={errors.txtCompanyAddressStreet} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Número</label>
                                                <input type={'number'} placeholder="Ex.: 1.200" {...register("txtCompanyAddressNumber", { required: true })} required={errors.txtCompanyAddressNumber} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Complemento</label>
                                                <input type={'text'} placeholder="Ex.: Sala 12" {...register("txtCompanyAddressComplement")} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Bairro</label>
                                                <input type={'text'} placeholder="Ex.: Jardim América" {...register("txtCompanyAddressNeighborhood", { required: true })} required={errors.txtCompanyAddressNeighborhood} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>CEP</label>
                                                <InputMask type={'text'} placeholder="Ex.: 02030-010" mask="99999-999" maskChar=" " {...register("txtCompanyAddressPostalCode", { required: true })} required={errors.txtCompanyAddressPostalCode} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Cidade</label>
                                                <input type={'text'} placeholder="Ex.: São Paulo" {...register("txtCompanyAddressCity", { required: true })} required={errors.txtCompanyAddressCity} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>UF</label>
                                                <select className="form-select" {...register("ddlCompanyAddressFederativeUnit", { required: true })} required={errors.ddlCompanyAddressFederativeUnit}>
                                                    <option value={''}></option>
                                                    <option value={'Acre'}>Acre</option>
                                                    <option value={'Alagoas'}>Alagoas</option>
                                                    <option value={'Amapá'}>Amapá</option>
                                                    <option value={'Amazonas'}>Amazonas</option>
                                                    <option value={'Bahia'}>Bahia</option>
                                                    <option value={'Ceará'}>Ceará</option>
                                                    <option value={'Distrito Federal'}>Distrito Federal</option>
                                                    <option value={'Espírito Santo'}>Espírito Santo</option>
                                                    <option value={'Goiás'}>Goiás</option>
                                                    <option value={'Maranhão'}>Maranhão</option>
                                                    <option value={'Mato Grosso'}>Mato Grosso</option>
                                                    <option value={'Mato Grosso do Sul'}>Mato Grosso do Sul</option>
                                                    <option value={'Minas Gerais'}>Minas Gerais</option>
                                                    <option value={'Paraíba'}>Paraíba</option>
                                                    <option value={'Paraná'}>Paraná</option>
                                                    <option value={'Pernambuco'}>Pernambuco</option>
                                                    <option value={'Piauí'}>Piauí</option>
                                                    <option value={'Rio de Janeiro'}>Rio de Janeiro</option>
                                                    <option value={'Rio Grande do Norte'}>Rio Grande do Norte</option>
                                                    <option value={'Rio Grande do Sul'}>Rio Grande do Sul</option>
                                                    <option value={'Rondônia'}>Rondônia</option>
                                                    <option value={'Roraima'}>Roraima</option>
                                                    <option value={'Santa Catarina'}>Santa Catarina</option>
                                                    <option value={'São Paulo'}>São Paulo</option>
                                                    <option value={'Sergipe'}>Sergipe</option>
                                                    <option value={'Tocantins'}>Tocantins</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Salário</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        placeholder={'Ex.: 5.000,00'}
                                                        prefix='R$ '
                                                        required={errors.txtSalary}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtSalary"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Outras Rendas</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        placeholder={'Ex.: 1.000,00'}
                                                        prefix='R$ '
                                                        required={errors.txtOtherIncome}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtOtherIncome"
                                                    control={control} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="listing_info_box bg-white rounded mt-40" id="bank_reference_data">
                                    <h5 className="mb-4">Referência Bancária</h5>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Banco</label>
                                                <input type={'text'} placeholder="Ex.: Banco do Brasil" {...register("txtBankName", { required: true })} required={errors.txtBankName} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Agência</label>
                                                <input type={'text'} placeholder="Ex.: 0001" {...register("txtBankAgency", { required: true })} required={errors.txtBankAgency} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Conta</label>
                                                <input type={'text'} placeholder="Ex.: 123456-0" {...register("txtBankAccount", { required: true })} required={errors.txtBankAccount} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Cliente Desde</label>
                                                <input type={'date'} {...register("txtBankCustomerSince", { required: true })} required={errors.txtBankCustomerSince} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    formPost.isError
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="error-badge bg-primary-light rounded d-block">{formPost.errorText}</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    formPost.isSuccess
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="success-badge bg-primary-success rounded d-block">Ficha de financiamento enviada com sucesso, aguarde o retorno de nossa equipe!</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                <div className="form-btns d-flex align-items-center mt-40">
                                    <button
                                        type="submit"
                                        disabled={formPost.isLoading}
                                        className="btn btn-primary-contact">
                                        Enviar Dados<span className="ms-2"><i className="fa-solid fa-arrow-right"></i></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}